import { assetsPath } from "../../utils";

const title = {
  en:
    "Latest News/Promotions",
  cn:
    "最新消息 / 优惠促销",
  ru:
    "Последние новости / Акции"
};

const content = [
  {
    image: "https://lagunaproperty.com/uploads/media/media/0001/04/43493e4794561a40c82be14f9b4a2f1328932146.jpeg",
    text: {
      en:
        "<p>Banyan Tree Group Nurtures Growing  Residential Community With Launch Of Laguna Park Phase Two</p>",
      cn:
        "",
      ru:
        ""
    },
    date: {
      en: "September 7, 2018",
      cn: "September 7, 2018",
      ru: "September 7, 2018",
    }
  },
  {
    image: "https://lagunaproperty.com/uploads/media/media/0001/04/43493e4794561a40c82be14f9b4a2f1328932146.jpeg",
    text: {
      en:
        "<p>Banyan Tree Group Nurtures Growing  Residential Community With Launch Of Laguna Park Phase Two</p>",
      cn:
        "",
      ru:
        ""
    },
    date: {
      en: "September 7, 2018",
      cn: "September 7, 2018",
      ru: "September 7, 2018",
    }
  }
];

const button = {
  en:
    "Learn more >",
  cn:
    "了解更多 >",
  ru:
    "Подробнее >"
};

export default {
  title,
  content,
  button
};



// WEBPACK FOOTER //
// ./src/data/Home/promotion.js